var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOmega(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 472C448 476.422 444.422 480 440 480H288C283.578 480 280 476.422 280 472V440.812C280 437.281 282.312 434.172 285.688 433.156C373.203 406.656 432 331.141 432 245.25C432 136.484 338.688 48 224 48S16 136.484 16 245.25C16 331.141 74.797 406.656 162.312 433.156C165.688 434.172 168 437.281 168 440.812V472C168 476.422 164.422 480 160 480H8C3.578 480 0 476.422 0 472S3.578 464 8 464H152V446.672C60.828 416.609 0 336.375 0 245.25C0 127.656 100.484 32 224 32S448 127.656 448 245.25C448 336.375 387.172 416.609 296 446.672V464H440C444.422 464 448 467.578 448 472Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmega);
export default __webpack_public_path__ + "static/media/omega.93b7de269d1c36decd7c2ed1f2301a9d.svg";
export { ForwardRef as ReactComponent };